import "./App.css";
import {Routes,Route, useNavigate} from "react-router-dom";
import Home from "./pages/Home";
import MinHome from "./pages/MiniWebsite/Home";
import Contact from "./pages/Contact";
import Contactlogin from "./pages/Contact-login";
import About from "./pages/About";
import Cart from "./pages/Cart";
import Wishlist from "./pages/Wishlist";
import Checkout from "./pages/Checkout";
import Productdetails from "./pages/Productdetails";
import Productdetailstest from "./pages/Productdetailstest";
import Category from "./pages/Category";
import Myaccount from "./pages/Myaccount";
import Profile from "./pages/profilepage/Profile";
import OrderHistoryDetails from "./pages/OrderHistoryDetails";
import Credit from "./pages/Credit";
import OrderHistorytwo from "./pages/OrderHistorytwo";
import Productdetailstwo from "./pages/Productdetailstwo";
import Thankyoupage from "./pages/Thankyoupage";
import Termsconditions from "./pages/Termsconditions";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import Pay from "./pages/Pay";
import Categoryforbrand from "./pages/Category-for-brand";
// import MiniCategory from "./pages/MiniWebsite/CategoryMini";
import MiniCategory from "./pages/NewCategorypage/CategoryMini";
import { bulk, tokenstore } from "./Localstorage/Store";
import Verifyotp from "./pages/Verify-otp";
import Categoryforsearch from "./pages/Category-for-search";
import Trackorder from "./pages/Trackorder";
import OrderHistoryWithOutLogin from "./pages/OrderHistoryWithOutLogin";
import Thankyoupagelogin from "./pages/Thankyoupagelogin";
import Landigpage from "./pages/Landigpage";
import Clientloginpage from "./pages/Clientloginpage";
import Voucherloginpage from "./pages/Voucherloginpage";
import Voucherrequest from "./pages/Voucherrequest";
import Register1 from "./pages/Register1";
import Register2 from "./pages/Register2";
import Register3 from "./pages/Register3";
import Register4 from "./pages/Register4";
import Register5 from "./pages/Register5";
import Useragreement from "./pages/Useragreement";
import Voucherrequestlist from "./pages/Voucherrequestlist";
import Test from "./pages/Registerbusiness/Test";
import Thankyouonboarding from "./pages/Thankyouonboarding";
import Register1part2 from "./pages/Register1part2";
import Creditrequestlist from "./pages/Creditrequestlist";
import Creditrequest from "./pages/Creditrequest";
import Mycredit from "./pages/Mycredit";
import Tracksingleorder from "./pages/Tracksingleorder";
import Changeyourpassword from "./pages/Changeyourpassword";
import Theam from "./pages/theam/Theam";
import OrderRequest from "./pages/Order_Request/OrderRequest";
import RedirectionComp from "./components/RedirectionComp";
import BulkProductdetails from "./pages/MiniWebsite/Productdetails";
import BulkCart from "./pages/MiniWebsite/Cart";
import SaveCartList from "./pages/SaveCart/SaveCartList";
import axios from "axios";
import { useEffect } from "react";
import SaveCartPay from "./pages/SaveCartPay/SaveCartPay";
import NewCart from "./pages/Cart/Cart";
import CompanyRegistrationForm from "./pages/NewRegForm/CompanyRegistrationForm";
import OrderHistoryDetailsTrackOrder from "./pages/OrderHistoryDetailsTrackOrder";




function App() {
  const nvg = useNavigate()
  const getkey = async () => {
    const urlParams = new URLSearchParams(window.location.search);
    const key = urlParams.get("key"); 
    if (key) {
      try {
        const Tokendata = { key: key };
        let url = `${process.env.REACT_APP_API_URL}bulk_product/get-token/`;
        const response = await axios.post(url, Tokendata);

        let correctedData = response.data.token.replace(/'/g, '"').replace(/True/g, 'true').replace(/False/g, 'false'); 
        let tokenData = JSON.parse(correctedData);
        tokenstore(tokenData)
        bulk(false);
        nvg('/home');
      } catch (error) {
        console.error("Error processing token:", error);
      }
  
    }
  
  };

  useEffect(()=>{
    getkey();
      },[])

  return (
    <div className="App">
      <Routes >
        <Route path="/" element={<Landigpage />} />
        <Route path="/registerbusiness" element={<CompanyRegistrationForm />} />
        <Route path="/clientlogin" element={<Clientloginpage />} />
        <Route path="/voucherlogin" element={<Voucherloginpage />} />
        <Route path="/home" element={<RedirectionComp page={<Home />} />} />
        <Route path="/minihome" element={<RedirectionComp page={<MinHome />} />} />
        <Route path="/contact" element={<Contact />} /> 
        <Route path="/track-order" element={<Trackorder />} /> 
        <Route path="/contactlogin" element={<RedirectionComp page={<Contactlogin />} />} />
        {/* <Route path="/registerbusiness" element={<Register1 />} /> */}
        <Route path="/registerbusiness2" element={<Register1part2 />} />
        <Route path="/about" element={<About />} />
        <Route path="/mycredit" element={<Mycredit />} />
        <Route path="/creditrequest" element={<Creditrequestlist />} />
        <Route path="/addcreditrequest" element={<Creditrequest />} />
        <Route path="/cart" element={<RedirectionComp page={<Cart />} />} />
        <Route path="/wishlist" element={<RedirectionComp page={<Wishlist />} />} />
        <Route path="/checkout/" element={<RedirectionComp page={<Checkout />} />} />
        <Route path="/pay" element={<RedirectionComp page={<Pay />} />}  />
        <Route path="/myaccount" element={<RedirectionComp page={<Myaccount />} />}  />
        <Route path="/productdetails" element={<RedirectionComp page={<Productdetails />} />}  />
       <Route
  path="/productdetails/:id/:name"
  element={<RedirectionComp page={<Productdetailstest />} />}
/>
        <Route path="/productdetailstwo" element={<RedirectionComp page={<Productdetailstwo />} />}  />
        {/* <Route path="/category/:id/:name/:url" element={<RedirectionComp page={<Category />} />}  /> */} old
        <Route path="/category/:id/:name/:url" element={<RedirectionComp page={<MiniCategory />} />}  />
        <Route path="/categoryforbrand/:name" element={<RedirectionComp page={<Categoryforbrand />} />}  />
        <Route path="/categoryforsearch/:name" element={<RedirectionComp page={<Categoryforsearch />} />}  />
        <Route path="/profile" element={<RedirectionComp page={<Profile/>}/>} />
        <Route path="/theam" element={<RedirectionComp page={<Theam />} />} />
        <Route path="/order-history-detail/:orderid" element={<RedirectionComp page={<OrderHistoryDetails />} />} />
        <Route path="/tracksingleorder/:orderid" element={<Tracksingleorder/>} />
        <Route path="/order-history" element={<RedirectionComp page={<OrderHistorytwo />} />} />
        <Route path="/save-cart-list" element={<RedirectionComp page={<SaveCartList />} />} />
        <Route path="/new-cart" element={<RedirectionComp page={<NewCart />} />} />
        <Route path="/saved-cart-pay/:orderid" element={<RedirectionComp page={<SaveCartPay />} />} />
        <Route path="/order-request/:orderid" element={<RedirectionComp page={<OrderRequest />} />} />
        <Route path="/changeyourpassword" element={<RedirectionComp page={<Changeyourpassword />} />} />
        <Route path="/voucher-request-add" element={<RedirectionComp page={<Voucherrequest />} />} />
        <Route path="/voucher-request" element={<RedirectionComp page={<Voucherrequestlist />} />} />
        <Route path="/credit" element={<RedirectionComp page={<Credit />} />} />
        <Route path="/thankyoupage" element={<RedirectionComp page={<Thankyoupage />} />} />
        <Route path="/useragreement" element={<Useragreement/>} />
        <Route path="/privacypolicy" element={<PrivacyPolicy/>} />
        <Route path="/register2" element={<Register2/>} />
        <Route path="/register3" element={<Register3/>} />
        <Route path="/register4" element={<Register4/>} />
        <Route path="/register5" element={<Register5/>} />
        <Route path="/thankyoupagelogin" element={<Thankyoupagelogin/>} />
        <Route path="/thankyoupageforonboarding" element={<Thankyouonboarding/>} />
        <Route path="/termsconditions" element={<Termsconditions/>} />
        <Route path="/track-order-list" element={<OrderHistoryWithOutLogin/>} />
        <Route path="/verify-otp/:userId" element={<Verifyotp/>} />
        <Route path="/order-history-detail-track/:orderid" element={<OrderHistoryDetailsTrackOrder />} />
        <Route path="*" element={<Clientloginpage />} />
        <Route path="/test" element={<Test />} />
        <Route path="/mini/category/:id/:name/:url" element={<RedirectionComp page={<MiniCategory />} bulk={true} />} />
        <Route path="/bulkproductdetails" element={<RedirectionComp page={<BulkProductdetails />} bulk={true} />} />
        <Route path="/bulkcart" element={<RedirectionComp page={<BulkCart />} bulk={true} />} />

      </Routes>
    </div>
  )

}

export default App;
